import { jsx as _jsx, jsxs as _jsxs } from "@redneckz/uni-jsx/jsx-runtime";
import { JSX } from '@redneckz/uni-jsx';
import { useCallback } from '@redneckz/uni-jsx/lib/hooks';
import { useBool } from '@redneckz/uni-jsx/lib/hooks/useBool';
import { useDebouncedEffect } from '@redneckz/uni-jsx/lib/hooks/useDebouncedEffect';
import { CloseButton } from '../../ui-kit/DialogManager/CloseButton.js';
import { RichText } from '../../ui-kit/RichText/RichText.js';
const COOKIE_DIALOG_ID = 'cookie';
const DIALOG_INITIAL_DELAY = 3 * 1000;
export const CookiePopup = JSX(({ __html }) => {
    const [opened, { setTrue: open, setFalse: close }] = useBool();
    useDebouncedEffect(() => {
        if (!globalThis.localStorage?.getItem(COOKIE_DIALOG_ID)) {
            open();
        }
    }, [], DIALOG_INITIAL_DELAY);
    const handleClose = useCallback(() => {
        globalThis.localStorage?.setItem(COOKIE_DIALOG_ID, 'true');
        close();
    }, []);
    return opened && __html ? (_jsx("div", { className: "container fixed left-0 right-0 bottom-0 z-50", role: "dialog", children: _jsxs("div", { className: "bg-white m-xl p-xl rounded-md flex sm:items-center shadow-main-black", children: [_jsx("div", { className: "sm:flex-1", children: _jsx(RichText, { __html: __html }) }), _jsx("div", { className: "ml-s sm:ml-0 w-36 flex justify-end", children: _jsx(CloseButton, { className: "bg-main-gray rounded-md w-11 h-11", onClose: handleClose }) })] }) })) : null;
});
//# sourceMappingURL=CookiePopup.js.map